import AxiosService from './AxiosService'

class InfoRestService {
  static getVersions(): Promise<any> {
    return AxiosService.get('/info/versions')
  }

  static downloadHealthInfo(): Promise<any> {
    return AxiosService.get('/info/healthInfo', {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        console.log(progressEvent)
      },
    })
  }

  static downloadLogFile(): Promise<any> {
    return AxiosService.get('/info/log', {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        console.log(progressEvent)
      },
    })
  }

  static getDatabaseConfig(): Promise<any> {
    return AxiosService.get('/info/database')
  }
}

export default InfoRestService
